import { connect } from 'react-redux';

import { updateBookingEntry } from '../../../actions/booking-entry-actions';
import BulkEditBookingEntries from './BulkEditBookingEntries';

const mapDispatchToProps = { onUpdate: updateBookingEntry };

export default connect(null, mapDispatchToProps)(BulkEditBookingEntries);
